export default "__VITE_ASSET__DFDVJFlt__"